import React, { useState, useEffect, useContext } from "react";
import { Card, Descriptions, Divider, PageHeader } from "antd";
import _ from "lodash";
import { LanguageContext } from "../../../context/LanguageContext";
// import moment from 'moment';
// import { CodeSandboxCircleFilled } from "@ant-design/icons";
export const ViewFormModel = (props) => {
  const { t } = useContext(LanguageContext);
  const [basicInfo, setbasicInfor] = useState([]);
  const [gunhaInfo, setGunhaInfo] = useState([]);
  const {
    pc_cities,
    pc_status,
    pc_crimetitles,
    pc_crimetypes,
    pc_countrystates,
  } = props.dataStates;

  useEffect(
    (res) => {
      if (props && props.viewList && props.viewList.basicInfo) {
        let tempbasic = {
          ...props.viewList.basicInfo[0],
        };
        //console.log("tempbasic",props.viewList.basicInfo[0]);
        setbasicInfor([tempbasic]);
      }
      if (props && props.viewList && props.viewList.gunhaInfor) {
        let temp =
          props.viewList.gunhaInfor &&
          props.viewList.gunhaInfor.map((item) => {
            return {
              ...item,
              // statusDate:item.statusDate?moment(item.statusDate).format('YYYY-DD-MM'):null,
              // registernumberYear:item.registernumberYear?moment(item.registernumberYear).format('YYYY'):null,
              // dateTime:item.dateTime?moment(item.dateTime).format('YYYY-DD-MM'):null
            };
          });
        setGunhaInfo([...temp]);
      }
    },
    [props]
  );

  // STATE
  const getStateName = (id) => {
    if (pc_countrystates && pc_countrystates.length) {
      return (
        _.filter(pc_countrystates, function (o) {
          return o.id === parseInt(id);
        })[0] &&
        _.filter(pc_countrystates, function (o) {
          return o.id === parseInt(id);
        })[0].state
      );
    }
  };

  // CITY
  const getCityName = (id) => {
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === parseInt(id);
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === parseInt(id);
        })[0].City
      );
    }
  };

  return (
    <div key="1">
      <PageHeader
        ghost={false}
        onBack={false}
        title={t("wanted")}
        subTitle={t("wanted")}
      >
        <Descriptions size="small" column={1}>
          <Descriptions.Item>
            {basicInfo && basicInfo.length
              ? basicInfo[0].uploadedFileUrl && (
                  <Card
                    className="viewCard"
                    hoverable
                    style={{ width: 100 }}
                    cover={
                      <img alt="example" src={basicInfo[0].uploadedFileUrl} />
                    }
                  ></Card>
                )
              : null}
          </Descriptions.Item>
        </Descriptions>
        {basicInfo && basicInfo.length ? (
          <>
            <div key="1">
              <Descriptions size="small" column={3}>
                <Descriptions.Item
                  style={{ fontWight: "bold" }}
                  label={t("name_of_the_accused")}
                >
                  <div style={{ fontWeight: "bold", fontSize: 16 }}>
                    {basicInfo && basicInfo[0].fullName}
                  </div>
                </Descriptions.Item>
                <Descriptions.Item label={t("address")}>
                  {basicInfo && basicInfo[0].address}
                </Descriptions.Item>

                <Descriptions.Item label={t("state")}>
                  {getStateName(basicInfo && basicInfo[0].state)}
                </Descriptions.Item>
                <Descriptions.Item label={t("component")}>
                  {getCityName(basicInfo && basicInfo[0].cityId)}
                </Descriptions.Item>
                <Descriptions.Item label={t("police_station")}>
                  {basicInfo && basicInfo[0].districtName}
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
        ) : null}
      </PageHeader>
      <Divider style={{ margin: "10px 0px" }} />
      <PageHeader
        ghost={false}
        onBack={false}
        title={t("crime")}
        subTitle={t("professional_criminal")}
      >
        {gunhaInfo &&
          gunhaInfo.map((ginfo, index) => (
            <>
              <div key={index + 1}>
                <Divider orientation="left" style={{ margin: "10px 0px" }}>
                  {t("crime") + " - "}
                  {index + 1}
                </Divider>
                <Descriptions size="small" column={3}>
                  <Descriptions.Item label={t("crime_state")}>
                    {getStateName(ginfo.ghunhastate)}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("crime_district")}>
                    {getCityName(ginfo.ghunhacity)}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("police_station_of_crime")}>
                    {ginfo.ghunhadistrictName}
                  </Descriptions.Item>
                  <Descriptions.Item label="गु.र.नंबर">
                    {ginfo.regsiterNumber}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("crime_register_year")}>
                    {ginfo.registernumberYear}
                  </Descriptions.Item>
                </Descriptions>
                <Divider style={{ margin: "10px 0px" }} orientation="left">
                  {t("law")} - {t("section")}
                </Divider>
                <Descriptions size="small" column={2}>
                  {ginfo &&
                    ginfo.kalamAndkayda.map((res) => (
                      <>
                        <Descriptions.Item label={t("section")}>
                          {res.rulesName}
                        </Descriptions.Item>
                        <Descriptions.Item label={t("section")}>
                          {res.kalam}
                        </Descriptions.Item>
                      </>
                    ))}
                </Descriptions>
              </div>
            </>
          ))}
      </PageHeader>
    </div>
  );
};
